<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import ManageAllocationCalendarInfobox from '../ManageAllocationCalendarInfobox/ManageAllocationCalendarInfobox.vue';
import ManageAllocationCalendarElement from '../ManageAllocationCalendarElement/ManageAllocationCalendarElement.vue'
import ManageAllocationCalendarWeekdays from '../ManageAllocationCalendarWeekdays/ManageAllocationCalendarWeekdays.vue'
import DropDownMenu from '../DropdownMenu/DropdownMenu.vue';
import Fake from '../Fake/Fake.vue';

export default {
    components: {
        ManageAllocationCalendarInfobox,
        ManageAllocationCalendarElement,
        ManageAllocationCalendarWeekdays,
        DropDownMenu,
        Fake
    },
    data() {
        return {
            showInfo: false,
        }
    },
    computed: {
        ...mapState({
            noContent: state => state.allocation.calendar.noContent,
            loading: state => state.allocation.calendar.loading,
            error: state => state.allocation.calendar.error,
            startMonth: state => state.allocation.calendar.startMonth,
            endMonth: state => state.allocation.calendar.endMonth,
            choices: state => state.allocation.calendar.display.choices,
            choice: state => state.allocation.calendar.display.choice,
        }),
        ...mapGetters({
            calendar: 'allocation/getCalendar',
            calendarPaginated: 'allocation/getCalendarPaginated'
        })
    },
    methods: {
        ...mapActions({
            toggleModal: 'allocation/toggleModal',
            incrementCalendarPage: 'allocation/incrementCalendarPage',
            decrementCalendarPage: 'allocation/decrementCalendarPage',
            choseCalendarDisplay: 'allocation/choseCalendarDisplay',
            toggleCalendarInfoBox: 'allocation/toggleCalendarInfoBox',
            getAllocationCalendar: 'allocation/getAllocationCalendar'
        }),
        pageUp() {
            if(this.startMonth >= 3) {
                this.incrementCalendarPage()
            }
        },
        pageDown() {
            if(this.endMonth < 12) {
                this.decrementCalendarPage()
            }
        },
        chooseDisplay(value) {
            this.choseCalendarDisplay(value);
        }
    }
}
</script>

<template>
    <div class="manage-allocation-calendar">
        <div class="manage-allocation-calendar__header">
            <div class="manage-allocation-calendar__heading">
                {{ $t('manageAllocationCalendar.header.heading') }}
            </div>
            <div v-if="!showInfo" class="manage-allocation-calendar__info" @click="toggleCalendarInfoBox">
                <span class="manage-allocation-calendar__info-label">
                    {{ $t('manageAllocationCalendar.header.howTo') }}
                </span>
                <span class="manage-allocation-calendar__info-icon">
                    <i class="fa fa-info-circle" @click="toggleCalendarInfoBox()"/>
                </span>
            </div>
            <div class="manage-allocation-calendar__dropdown">
                <drop-down-menu
                    :items="choices"
                    :value="choice"
                    :translation-prefix="'manageAllocationCalendar.dropdown'"
                    :searchable="false"
                    :label="$t('bookingList.display.label')"
                    @input="chooseDisplay"/>
            </div>
        </div>
        <div v-if="!error && !noContent && !loading"
             :class="['manage-allocation-calendar__body', (choice === 'full') ? 'full' : null]">
            <div class="manage-allocation-calendar__months">
                <div v-for="(month, index) in (choice === 'full') ? calendar : calendarPaginated"
                     :key="index"
                     class="manage-allocation-calendar__wrapper">
                    <div class="manage-allocation-calendar__month">
                        <div class="manage-allocation-calendar__label">
                            {{ $t('manageAllocationCalendar.months.' + month.index) }}
                        </div>
                        <div class="manage-allocation-calendar__weekdays">
                            <manage-allocation-calendar-weekdays/>
                        </div>
                        <div v-for="(week, index) in month.weeks"
                             :key="index"
                             class="manage-allocation-calendar__weeks">
                            <div class="manage-allocation-calendar__week">
                                {{ week.number }}
                            </div>
                            <div v-for="(day, dayNo) in week.days"
                                 :key="dayNo"
                                 class="manage-allocation-calendar__days">
                                <manage-allocation-calendar-element
                                    v-if="!day.day"
                                    allocation-type="empty"/>
                                <manage-allocation-calendar-element
                                    v-if="day.day"
                                    :allocation-type="day.data.allocationType"
                                    :date="day.day"
                                    :units="day.data.currentUnits"
                                    :index="day.index"
                                    :past="day.past"
                                    :current="day.currentDay"
                                    :arrival="day.data.arrival"
                                    :request="day.data.request"
                                    :tooltip="{bookings: day.data.bookings, initialUnits: day.data.initialUnits}"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="choice !== 'full'" class="manage-allocation-calendar__controls">
                <button :disabled="startMonth === 0" class="manage-allocation-calendar__page-btn" @click="pageUp">
                    <i class="fa fa-chevron-up"/>
                </button>
                <button :disabled="endMonth === 12" class="manage-allocation-calendar__page-btn" @click="pageDown">
                    <i class="fa fa-chevron-down"/>
                </button>
            </div>
        </div>
        <div v-if="!loading && error"
             :key="'error'"
             class="manage-allocation-calendar__error">
            <i class="fa fa-exclamation-circle"/>
            <div class="manage-allocation-calendar__error-message">
                {{ $t('manageAllocationCalendar.error') }}
            </div>
            <div class="manage-allocation-calendar__error-retry" @click="getAllocationCalendar">
                {{ $t('manageAllocationCalendar.retry') }}
            </div>
        </div>
        <fake v-if="loading"
              :header-rows="1"
              :body-rows="10"
              :body-cells="4"
              :key="'fake'"/>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ManageAllocationCalendar/ManageAllocationCalendar.vue